import { render, staticRenderFns } from "./AlertGroup.vue?vue&type=template&id=6c792b78&scoped=true&"
import script from "./AlertGroup.vue?vue&type=script&lang=js&"
export * from "./AlertGroup.vue?vue&type=script&lang=js&"
import style0 from "./AlertGroup.vue?vue&type=style&index=0&id=6c792b78&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c792b78",
  null
  
)

export default component.exports